import React, { Component } from 'react';

import FontFaceObserver from 'fontfaceobserver';
import PropTypes from 'prop-types';

import { TEXT_CONFIGS } from '../constants';
import CanvasMenuSelect from '../menu/CanvasMenuSelect';

export default class CanvasTextFontFamily extends Component {
  static propTypes = {
    canvasRef: PropTypes.object,
    onUpdate: PropTypes.func,
    updateInfo: PropTypes.func,
    fontFamily: PropTypes.string
  };

  async componentDidMount() {
    await this.loadCustomFont();
  }

  async loadCustomFont() {
    const myfont = new FontFaceObserver('edwardian script itc');

    await myfont.load();
  }

  groupApplyFontFamily(family) {
    const { canvasRef, onUpdate, updateInfo } = this.props;

    const activeObjects = canvasRef.getActiveObjects();

    activeObjects.forEach((object) => {
      object.set({ fontFamily: family.value });
    });

    canvasRef.renderAll();

    onUpdate();
    updateInfo();
  }

  fontCorrespondingLabel(value) {
    const fonts = TEXT_CONFIGS.DEFINED_FONTS_FAMILY;
    const selectedFont = fonts.find((item) => item.value === value);

    return selectedFont ? selectedFont.label : '';
  }

  render() {
    const family = TEXT_CONFIGS.DEFINED_FONTS_FAMILY;
    const { fontFamily } = this.props;
    const fontLabel = this.fontCorrespondingLabel(fontFamily) || ' ';

    return (
      <CanvasMenuSelect
        onChange={this.groupApplyFontFamily.bind(this)}
        options={family}
        value={fontFamily}
        placeholder={fontLabel}
        toolTip="canvas-editor.text.font.family"
        className="canvas-menu__select-font-family"
        translatable={false}
      />
    );
  }
}
